import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import Cookies from 'js-cookie'
import moment from 'moment'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/scss/element-variables.scss'
// 国际化
// import i18n from './assets/lang'
import locale from 'element-ui/lib/locale/lang/en'

import '@/router/permission'

import '@/assets/fonts/iconfont.js'
import '@/assets/fonts/iconfont.css'

Vue.config.productionTip = false

Vue.prototype.$moment = moment

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  // i18n: (key, value) => i18n.t(key, value)
  locale
})

router.beforeEach((to, from, next) => {
  let historyList = store.getters.historyList
  let historyObj = {
    name: to.name,
    title: to.meta.title,
    url: to.fullPath,
    icon: to.matched.length > 0 ? to.matched[0].meta.icon : ''
  }
  if (to.name === 'MemberDetail') {
    historyObj.title = `${to.meta.title} (ID: ${to.query.userId})`
  }
  if (to.name === 'TournamentConfig') {
    historyObj.title = `${to.meta.title} (ChannelID: ${to.query.merchantId})`
  }
  historyList.push(historyObj)
  // 去重
  for (let i = 0; i < historyList.length - 1; i++) {
    for (let j = i + 1; j < historyList.length; j++) {
      if (historyList[i].url == historyList[j].url) {
        historyList.splice(j, 1)
        //注意这里要j--，splice删除了一个元素，下标要减一，否则循环会漏掉一个元素
        j--
      }
    }
  }
  store.dispatch('app/setHisList', historyList)
  let userToken = to.query.token
  if (userToken) {
    Cookies.set('token', userToken)
  }

  next()
})

new Vue({
  router,
  store,
  // i18n,
  render: h => h(App)
}).$mount('#app')
